<template>
    <v-dialog v-model="dialog" width="500" style="background-color:white">
    <v-card>
      <EncabezadoModal titulo="Detalle de la nota crédito DE" icono="mdi-text-box-search-outline" @cerrar="dialog = false" />
      <v-card-text class="pt-4">
      <v-row no-gutters>
                                                            
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('credit_note_date')}}:
                    {{ $filters.datetime(item.credit_note_date) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('consecutive_credit_note')}}:
                    {{ item.consecutive_credit_note }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('invoice')}}:
                    {{ $filters.name(item.invoice) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('is_validate')}}:
                    {{ $filters.boolean(item.is_validate) }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('status_dian')}}:
                    {{ item.status_dian }}
                </v-col>
                                                                
                <v-col cols="12" class=" list-mobile-field">
                    {{$t('total_note')}}:
                    {{ $filters.currency(item.total_note) }}
                </v-col>
                                            </v-row>
      </v-card-text>
            <v-card-actions class="d-flex justify-end">
                <v-btn color="secondary" @click="dialog = false;" small class="btn--close" >
                <v-icon small>mdi-close</v-icon>{{$t('Cerrar')}} </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        data() {
            return {
                dialog: false,
                item: {}
            };
        },
        methods: {
            renderItem(item) {
                this.item = item;
                this.dialog = true;
            }
        }
    }
</script>
